import { Trash2 } from "lucide-react";
import { Button } from "../ui/button";

interface StoryActionButtonsProps {
    status: string;
    onView: () => void;
    onDelete: () => void;
    variant?: "desktop" | "mobile";
}

export function StoryActionButtons({ status, onView, onDelete, variant = "desktop" }: StoryActionButtonsProps) {
    const buttonText = status === "finalized" ? "View" : "Continue";
    const mobileClass = variant === "mobile" ? "flex-1" : "";

    return (
        <div className={`flex items-center gap-2 ${variant === "desktop" ? "justify-end" : ""}`}>
            <Button size="sm" className={mobileClass} onClick={onView} variant="outline" aria-label={buttonText}>
                {buttonText}
            </Button>
            <Button
                size="sm"
                variant="ghost"
                onClick={onDelete}
                className="text-destructive hover:text-destructive/80 hover:bg-destructive/10 p-2"
                aria-label="Delete story"
            >
                <Trash2 className="h-4 w-4" />
            </Button>
        </div>
    );
}
